/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalRefrigeratorFreezerComboW24Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalRefrigeratorFreezerComboW24').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'REFRIGERATOR_LN24REF',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-refrigerator-freezer-combo-w-24.js.map